import { connect } from 'react-redux';
import { CookieBanner as CookieBannerComponent } from '@shared/components/cookieBanner';
import { createIsManageModalOpenAction, createSetWCPConsentAction, createSetIsConsentRequiredAction } from '@shared/actions/actions';
import { Constants } from '@shared/utils/constants';
const mapStateToProps = (state)=>{
    const { config: { locale = Constants.Cookies.WCPDefaultLocale, cookiesConsent, siteEnvironment } } = state;
    return {
        locale,
        isManagementModalOpen: cookiesConsent.isManageModalOpen,
        siteEnvironment
    };
};
const mapDispatchToProps = (dispatch)=>{
    return {
        resetCookieManagementModal: ()=>dispatch(createIsManageModalOpenAction(false)),
        updateSiteConsent: (consent)=>dispatch(createSetWCPConsentAction(consent)),
        updateIsConsentRequired: (consent)=>dispatch(createSetIsConsentRequiredAction(consent))
    };
};
export const CookieBanner = connect(mapStateToProps, mapDispatchToProps)(CookieBannerComponent);
